module.exports = __webpack_public_path__ + "img/003杨勇.1f8a7668.jpg";